export default __webpack_public_path__ + "b5852a1fe9bc67afe53d1d024f6fe4de.svg";